<template>
  <div class="release">
    <el-dialog
      :visible="dialogVisible"
      width="67%"
      @close="handleClose">
      <span sloat="title" class="release-header">完善预习内容</span>
      <div>
        <div class="release-name">
          <span class="release-name__text">预习名称 :</span>
          <el-col :span="16">
            <el-input v-model="searchForm.name" maxlength='30'></el-input>
          </el-col>
          <span class="release-name__text">{{searchForm.name.length}}/30</span>
        </div>
        <div class="release-preview">
          <span>预习知识点 :</span>
          <p>共{{checkedList.length}}个</p>
        </div>
        <div class="release-box">
          <div
            v-for="(kitem, i) in checkedList"
            :key="i"
            class="release-box__knowledge"
          >{{kitem.knowledge_name}}
          <i class="el-icon-circle-close" @click="removeList(kitem)"></i>
          </div>
        </div>
        <div class="release-designation">
          <span class="release-designation__text">预习对象 :</span>
          <el-cascader
            ref="cascader"
            :options="gradeList"
            style="width:100%"
            separator=""
            :props="{multiple:true, value: 'dl_code', label: 'name', children: 'class_infos'}"
            :class="errorProp==='targets'?'is-error':''"
            v-model="searchForm.targets"
            popper-class="c-cascader"
          >
          <template slot-scope="{ node, data }">
            <span>{{ data.name }}</span>
            <span
              v-if="!node.isLeaf&&getSelectedCount(data.academic_year_id)"
              class="c-cascader__count">
                {{ getSelectedCount(data.academic_year_id) }}
            </span>
          </template>
          </el-cascader>
        </div>
      </div>
      <footer v-if="errorType">
        <p class="release-error">
          *{{errorMessage}}
        </p>
      </footer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onCreateClick">发 布 预 习</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getTeacherClassYear, createEvaluate } from '@/api/pt';
import { debounce } from '@/utils';
import mixins from '../../mixins';

export default {
  name: 'ReleaseDialog',
  mixins: [mixins],
  props: {
    dialogVisible: {
      required: true,
      default: false,
    },
    checkedList: {
      required: true,
      default: () => [],
    },
    course: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isPad: this.$route.query.spad,
      errorProp: '',
      errorType: false,
      searchForm: {
        name: '',
        targets: '',
      },
      initialName: '',
      subjectList: [],
      versionList: [],
      stageList: [],
      gradeList: [],
      courseList: [],
      formedTargets: '',
      questionIds: '',
      errorMessage: '',
      subjectName: {
        1: '英语',
        2: '数学',
        3: '语文',
        4: '物理',
        5: '化学',
      },
    };
  },
  computed: {
  },
  watch: {
    'searchForm.targets': function refinedTargets(v) {
      if (!v) {
        return;
      }
      this.$nextTick(() => {
        this.formedTargets = this.$refs.cascader.checkedNodes.map((item) => ({
          grade_id: item.path[0],
          class_id: item.path[1],
          class_name: item.pathLabels[1],
          school_year: item.pathLabels[0],
        }));
      });
    },
    checkedList: {
      handler() {
        this.questionIds = this.checkedList.map((item) => item.knowledge_code);
      },
      deep: true,
      immediate: true,
    },
    'course.subjectId': {
      handler() {
        this.nameRule();
      },
      immediate: true,
      deep: true,
    },
  },
  activated() {
    this.getTeacherClassYear();
  },
  mounted() {
    this.getTeacherClassYear();
  },
  methods: {
    handleClose() {
      this.$emit('update:dialogVisible', false);
    },
    nameRule() {
      const myDate = new Date();
      const mm = myDate.getMonth() + 1;
      const dd = myDate.getDate();
      const time = (mm < 10 ? `0${mm}` : `${mm}`) + (dd < 10 ? `0${dd}` : `${dd}`);
      this.searchForm.name = `${time}《${this.course.lessonName}》课前预习`;
      this.initialName = this.searchForm.name;
    },
    onCreateClick: debounce(function create() {
      if (this.searchForm.name.length < 1 || this.searchForm.name.length > 30) {
        this.errorMessage = '请输入预习名称';
        this.errorType = true;
      }
      if (!this.searchForm.targets || this.searchForm.targets < 1) {
        this.errorMessage = '请选择预习对象';
        this.errorType = true;
      }
      if (this.searchForm.name.length > 1 && this.searchForm.targets.length > 0) {
        this.errorType = false;
        createEvaluate({
          evaluate_name: this.searchForm.name,
          subject_id: this.course.subjectId,
          textbook_id: this.course.textbookId,
          evaluate_object: JSON.stringify(this.formedTargets),
          course_id: this.course.courseId,
          lesson_id: this.course.lessonId,
          app_id: 2,
          type: 2,
          question_ids: JSON.stringify(this.questionIds),
          is_sync: 0,
        }).then(() => {
          this.handleClose();
          this.$emit('onSuccess');
          this.searchForm.targets = [];
          this.searchForm.name = this.initialName;
        }).catch((e) => {
          console.log(e);
          this.$message.error(e.msg);
        });
      }
    }, 1000, true),
    removeList(kitem) {
      if (this.checkedList.length > 1) this.$emit('removeList', kitem);
      if (this.checkedList.length < 2) this.$message.error('不得少于一条');
    },
    getTeacherClassYear() {
      if (this.isPad) {
        return Promise.resolve();
      }
      return getTeacherClassYear().then((res) => {
        if (res.code === 200) {
          this.gradeList = res.data;
        }
      });
    },
    // 获取对应年级下已经选择的班级数量
    getSelectedCount(id) {
      if (!this.searchForm.targets) {
        return 0;
      }
      const len = this.$refs.cascader.checkedNodes
        .filter((item) => item.pathNodes[0].data.academic_year_id === id).length;
      return len;
    },
  },
};
</script>

<style lang='scss' scoped>
  .release {
    font-family: PingFangSC-Regular, PingFang SC;
    & /deep/ .el-dialog {
      height: 610px;
      padding-left: 50px;
      &__footer {
        float: left;
        position: relative;
        left: 108px;
      }
    }
    &-error {
      position: absolute;
      bottom: 118px;
      left: 182px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #F56C6C;
    }
    &-header {
      position: relative;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 33px;
      &::before {
        content: '';
        position: absolute;
        width: 3px;
        height: 16px;
        top: 10px;
        left: -30px;
        background: #1890FF;
        border-radius: 3px;
      }
      &::after {
        content: '';
        position: absolute;
        width: 143px;
        height: 13px;
        bottom: 5px;
        right: 0;
        background: rgba(230, 162, 60, 0.2);
        border-radius: 7px;
      }
    }
    &-name {
      display: flex;
      margin-top: 50px;
      width: 500px;
      height: 40px;
      justify-content: space-between;
      align-items: center;
      & /deep/ .el-input {
        width: 298px;
        margin: 0 12px;
      }
      &__text {
        width: 100px;
        font-size: 16px;
        font-weight: 400;
        color: #000;
        line-height: 16px;
      }
    }
    &-preview {
      width: 150px;
      display: flex;
      justify-content: space-between;
      margin-top: 32px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      span {
        position: relative;
        left: -15px;
      }
    }
    &-box {
      position: relative;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      left: 108px;
      margin-top: 14px;
      width: 50vw;
      height: 114px;
      overflow-y: auto;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #DCDFE6;
      &__knowledge {
        min-width: 102px;
        height: 24px;
        margin: 8px;
        padding: 5px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5A5E66;
        text-align: center;
        line-height: 24px;
        background: #F0F2F5;
        border-radius: 3px;
      }
    }
    &-designation {
      display: flex;
      margin-top: 50px;
      width: 400px;
      height: 40px;
      align-items: center;
      & /deep/ .el-cascader {
        width: 298px;
      }
      & /deep/ .el-cascader__tags {
        max-width: 792px !important;
        max-height: 80px;
        overflow-y: auto;
      }
      &__text {
        width: 26%;
        font-size: 16px;
        font-weight: 400;
        color: #000;
        line-height: 16px;
        margin-right: 35px;
      }
    }
  }
</style>
